
import { Component } from '@angular/core';

@Component({
	selector: 'loading',
	template: `		<pichincha-loading-screen
	description="Espera un momento por favor"
	isDesktop="true"
	customIconbodyColor="bp-primary-yellow500"
	customIconlineColor="bp-primary-blue500"
	fitToParent="true"

  >
  </pichincha-loading-screen>`,
	styleUrls: []
})

export class LoadingComponent {

}
